import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        level: '='
    },
    template: `
        <div class="well">
            <h2>{{ 'course.General data' | translate }}</h2>
            <form class="form" ng-submit="vm.save()">
                <form-wrapper form="vm.form">
                    <form-row error="vm.form.errors.value">
                        <label class="label">{{ 'user.Level name' | translate }} *</label>
                        <div class="items">
                            <input ng-model="vm.form.model.value" type="text" class="form-control">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                </form-wrapper>
                <button type="submit" class="hidden" >{{ 'general.Save changes' | translate }}</button>
            </form>
        </div>
        <ul class="actions01">
            <li class="primary">
                <a ng-click="vm.save()" class="btn main">
                    <span ng-if="vm.form.model.id">{{ 'user.Save level' | translate }}</span>
                    <span ng-if="!vm.form.model.id">{{ 'user.Add level' | translate }}</span>
                </a>
            </li>
            <li>
                <a ui-sref="authorized.user.group.list.level()" class="btn discrete" >
                    <span ng-if="vm.form.model.id">{{ 'general.Back to list' | translate }}</span>
                    <span ng-if="!vm.form.model.id">{{ 'general.Cancel' | translate }}</span>
                </a>
            </li>
        </ul>
`
})
export default class {
    constructor ($state, $translate, toastr) {
        this.$state = $state;
        this.$translate = $translate;
        this.toastr = toastr;
    }

    save () {
        this.form.save()
            .then((model) => {
                this.form.saved = false; // this is for avoiding duplicated success message through form wrapper, COUR-4308
                this.toastr.success(this.$translate.instant('general.Changes saved'));
                this.level = model;
                this.$state.go('authorized.user.group.detail.level', { id: model.id });
            });
    }
}




// WEBPACK FOOTER //
// ./src/app/components/user/group/form/level/index.js